import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { resetPassword } from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import { required, patterncheck, compare } from '../../util/validationMethods';
import { getSubDomain } from '../../util/subdomainHelper';
import TmInputGroup from '../../components/utilComponents/tmInputGroup/tmInputGroup';
import Background from '../../assets/img/bg_body.jpg';
import './login.css';

/**
 * ResetPassword Component
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Replaced deprecated componentWillMount → parse query string in constructor
 *  2. Fixed direct state mutation in onChangeValues
 *  3. Added try/catch around handleSubmit
 *  4. Removed unused imports (getSubDomain from customMethods)
 */

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    // Parse query string in constructor (replaces componentWillMount)
    const params = queryString.parse(props.location.search);

    this.state = {
      forgetToken: params.forgetToken || '',
      newPassword: '',
      conformPwd: '',
      empEmail: params.empEmail || '',
      userId: params.userid || '',
    };
  }

  onChangeValues = (event) => {
    const { name, value } = event.currentTarget;
    this.setState({ [name]: value });
  };

  handleSubmit = async () => {
    const { dispatch, history } = this.props;
    const { newPassword, forgetToken, empEmail, userId } = this.state;

    try {
      const res = await dispatch(
        resetPassword(newPassword, forgetToken, empEmail, userId, getSubDomain())
      );

      if (res.statusCode === 200) {
        notify.createNotification('success', res.message, this.props.refNotify);
        history.push('/login');
      } else {
        notify.createNotification('error', res.message, this.props.refNotify);
      }
    } catch (error) {
      console.error('Reset password error:', error);
      const message = error?.response?.data?.statusMsg || 'Failed to reset password. Please try again.';
      notify.createNotification('error', message, this.props.refNotify);
    }
  };

  render() {
    return (
      <section
        className="wrapper"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        }}
      >
        <div className="login-wrap d-flex align-items-center flex-wrap justify-content-center pd-20">
          <div className="login-box bg-white box-shadow pd-20 border-radius-5">
            <img
              src={require('../../assets/images/SVMS Logo Final-A-FULL-MED.png')}
              alt="NaviNet"
              className="login-img"
            />
            <h6 className="text-center mb-10">
              <strong>Reset Password</strong>
            </h6>
            <Form name="frmForgot" className="mb-lg">
              <Fragment>
                <div className="input-group custom input-group-lg">
                  <TmInputGroup
                    id="newPassword"
                    name="newPassword"
                    type="password"
                    placeholder="Enter Password"
                    className="form-control"
                    value={this.state.newPassword}
                    onChange={this.onChangeValues}
                    validations={[required, patterncheck]}
                    requiredmsg="Please enter password"
                    append="true"
                    appendText={
                      <div className="input-group-append custom">
                        <span className="input-group-text">
                          <i className="fa fa-lock" aria-hidden="true" />
                        </span>
                      </div>
                    }
                  />
                </div>
                <div className="input-group custom input-group-lg">
                  <TmInputGroup
                    id="conformPwd"
                    name="conformPwd"
                    type="password"
                    placeholder="Confirm Password"
                    className="form-control"
                    compareVal={this.state.newPassword}
                    value={this.state.conformPwd}
                    onChange={this.onChangeValues}
                    validations={[required, compare]}
                    requiredmsg="Please enter password"
                    append="true"
                    appendText={
                      <div className="input-group-append custom">
                        <span className="input-group-text">
                          <i className="fa fa-lock" aria-hidden="true" />
                        </span>
                      </div>
                    }
                  />
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="input-group">
                      <Button
                        type="button"
                        onClick={this.handleSubmit}
                        className="btn btn-outline-primary btn-lg btn-block"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </Fragment>
            </Form>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  authInfo: state.authInfo,
  refNotify: state.refNotify,
});

export default withRouter(connect(mapStateToProps)(ResetPassword));
